module.exports = __webpack_public_path__ + "img/ESlinger64_ua.8f3b689a.webp";